import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
import axios from 'axios';
import { apiUrl } from '../../../util/Api';
//import { useSelector } from 'react-redux';
//import { getUserAccounts } from '../../../app/slices/UserSlice';

//TODO: might be better to have one long form to add all the related keys
//otherwise form needs to be able to hide/show the other fields - only bedrock requires 3 fields

//TODO: provide info on how to sign up for keys 
//link to the providers sign up forms?

//import {string, object} from 'yup';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  apiKey: Yup.string().required('an api key is required'),
  providerId: Yup.string().required('a provider is required.')
});

const ProviderKeyForm = ({ updateProviderKeys, ...props }) => {
  //console.log("show ProviderKeyForm")
  const accountKey = props?.accountKey ? props.accountKey : '';
  const providerKeys = props?.providerKeys ? props.providerKeys : [];

  const [errors, setErrors] = useState([]);
  const [successMsg, setSuccessMsg] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [providers, setProviders] = useState([]);

  const [showSecretKey, setShowSecretKey] = useState(false);
  const [showSessionToken, setShowSessionToken] = useState(false);

  const [showForm, setShowForm] = useState(false)
  const [showAddBtn, setShowAddBtn] = useState(true)

  const submitSubmit = (values, actions) => {
    //console.log("submitting form", values);
    setSubmitting(true)
    setErrors([]);
    setSuccessMsg(null);

    axios.post(apiUrl + '/providerkeys/add', values, { withCredentials: true })
      .then((res) => {
        if (res.data.status === "ok") {
          setErrors([]);

          setSuccessMsg('The provider key was saved.')
          setShowForm(false);
          let temp = [...providerKeys]
          let providerKey = res.data.providerKey;
          providerKey.created = new Date().toLocaleDateString();
          //get provider name 
          let provider = providers.find(p => {
            return p.providerId === parseInt(providerKey.providerId)
          })
          //individually add fields:
          /*
          providerKey.provider = provider.provider;
          providerKey.reqApiKey = provider.reqApiKey;
          providerKey.reqSecretKey = provider.reqSecretKey;
          providerKey.reqSessionToken = provider.reqSessionToken;
          */
          //merge fields 
          providerKey = { ...providerKey, ...provider }
          temp.push(providerKey);
          //TODO: just remove the provider from the providers list!!
          //filterProviders(providers,temp);
          //let filtered = providers.filter(p => p.providerId !== providerKey.providerId)
          //setProviders(filtered);
          updateProviderKeys(temp);
        }
        else {

          let errorMsgs = [];

          res.data.errors.forEach((error, i) => {
            switch (error) {
              case 'no-permissions':
                errorMsgs.push('You do not have permissions to edit provider keys.');
                break;
              case 'no-provider':
                errorMsgs.push('Please select a provider');
                break;
              case 'no-keys':
                errorMsgs.push('Please enter the key for the provider');
                break;
              default:
                errorMsgs.push('There was an error setting the provider key.');
            }
          });
          setErrors(errorMsgs);
        }
        setSubmitting(false)
      })
      .catch((err) => {

        setErrors(['An error occurred while setting the provider key.']);
        setSubmitting(false)
      });
  }
  /*
    const updateForm = (providerId) => {
      //console.log(evt.currentTarget.value)
      //get the provider 
      let provider = providers.find(p => {
        return p.providerId === providerId
      })
      //check req fields and update appropriately
      if(provider.reqSecretKey === 1) {
        setShowSecretKey(true)
      } else {
        setShowSecretKey(false)
      }
      if(provider.reqSessionToken === 1) {
        setShowSessionToken(true)
      } else {
        setShowSessionToken(false)
      }
    }
    */
  /* 
  const filterProviders = (available, used) => {
    let existing = new Set(used.map(p => p.providerId))
    let filtered = available.filter(p => !existing.has(p.providerId))
    setProviders(filtered)
  }*/

  useEffect(() => {
    axios.get(apiUrl + '/genai-providers', { withCredentials: true })
      .then((res) => {
        if (res.data.status === 'ok') {
          let providers = res.data.providers;

          //TODO: need to filter list of providers to ones not already selected
          //setProviders(providers.filter(provider => provider.providerId >0 && provider.providerId < 3));
          //console.log('getting providers')
          //setProviders(providers)
          let existing = new Set(providerKeys.map(p => p.providerId))
          let filtered = providers.filter(p => !existing.has(p.providerId))
          setProviders(filtered)
          if(filtered.length > 0){
            //hide button!
            setShowAddBtn(true)
          } else {
            setShowAddBtn(false)
          }
          //filterProviders(providers, providerKeys)
        }
      })
      .catch((err) => {

      });
  }, [accountKey, providerKeys]);

  //check if logged in
  return (
    <div>
      {showAddBtn ? (
      <Button onClick={() => setShowForm(!showForm)} size='sm'>Add Provider</Button>
      ) : null}
      {
        errors.length > 0 ? (
          <Alert variant='danger' className='my-3'>
            {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
          </Alert>
        ) : (null)
      }
      {
        successMsg !== null ? (
          <Alert variant='info' className='my-3'>
            {successMsg}
          </Alert>
        ) : (null)
      }

      {showForm ? (
        <div className='chart-card mt-3'>
          <Formik validationSchema={validationSchema}
            onSubmit={submitSubmit}
            initialValues={{ apiKey: '', accountKey: accountKey, providerId: '', secretKey: '', sessionToken: '' }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              setFieldValue,
              values,
              touched,
              isValid,
              errors
            }) => (
              <Form noValidate onSubmit={handleSubmit} className='col-md-9 col-sm-9 col-lg-9'>
                <Form.Group controlId='provider-type' className='mb-3'>
                  <Form.Label>Provider <span className='required-field'>*</span></Form.Label>
                  <Form.Control as="select" name="providerId" onChange={e => {
                    handleChange(e)
                    //updateForm(e.currentTarget.value)
                    //console.log('e' + (typeof e.currentTarget.value))
                    let provider = providers.find(p => {
                      return p.providerId === parseInt(e.currentTarget.value)
                    })
                    //console.log(provider)
                    //check req fields and update appropriately
                    if (provider.reqSecretKey === 1) {
                      setShowSecretKey(true)
                    } else {
                      setShowSecretKey(false)
                    }
                    if (provider.reqSessionToken === 1) {
                      setShowSessionToken(true)
                    } else {
                      setShowSessionToken(false)
                    }
                    setFieldValue('secretKey', '');
                    setFieldValue('sessionToken', '');

                  }} isInvalid={touched.providerId && errors.providerId}>
                    <option value="">Select one</option>
                    {
                      providers.length > 0 ? (
                        <>
                          {providers.map((provider, i) => (<option key={'providers.' + i} value={provider.providerId}>{provider.provider}</option>))}
                        </>
                      ) : (null)
                    }
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">{errors.providerId}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId='api-key' className='mb-3'>
                  <Form.Label>API Key</Form.Label>
                  <Form.Control type="text" placeholder="API Key"
                    name="apiKey" value={values.apiKey} onChange={handleChange}
                    isInvalid={touched.apiKey && errors.apiKey}
                  />
                  <Form.Control.Feedback type="invalid">{errors.apiKey}</Form.Control.Feedback>
                </Form.Group>
                {showSecretKey === true ? (
                  <Form.Group controlId='secret-key' className='mb-3'>
                    <Form.Label>Secret Key</Form.Label>
                    <Form.Control type="text" placeholder="Secret Key"
                      name="secretKey" value={values.secretKey} onChange={handleChange}
                      isInvalid={touched.secretKey && errors.secretKey}
                    />
                    <Form.Control.Feedback type="invalid">{errors.secretKey}</Form.Control.Feedback>
                  </Form.Group>
                ) : null}
                {showSessionToken === true ? (
                  <Form.Group controlId='session-token' className='mb-3'>
                    <Form.Label>Session Token</Form.Label>
                    <Form.Control type="text" placeholder="Session Token"
                      name="sessionToken" value={values.sessionToken} onChange={handleChange}
                      isInvalid={touched.sessionToken && errors.sessionToken}
                    />
                    <Form.Control.Feedback type="invalid">{errors.sessionToken}</Form.Control.Feedback>
                  </Form.Group>
                ) : null}
                {submitting ? (
                  <Button variant="info" disabled size='sm'><Spinner as="span" animation="border" size="sm" /> Saving...</Button>
                ) : (
                  <Button variant="primary" type="submit" size='sm'>Save</Button>
                )}
              </Form>
            )}
          </Formik>
        </div>


      ) : (null)}


    </div>
  );
}


export default ProviderKeyForm;
